import { Toast, Tooltip } from './_bootstrap';

(function () {
	// * Tooltip initialization, remove it if not necessary
	document
		.querySelectorAll('[data-toggle="tooltip"]')
		.forEach((tooltipElement) => new Tooltip(tooltipElement));

	// * Toast initialization, remove it if not necessary
	document
		.querySelectorAll('.toast')
		.forEach((toastElement) => new Toast(toastElement));
})();

(function($) {
	$(document).ready(function() {

		$('.field-objects-photos').photobox('a',{ time:0 });
		$('.node--type-product .group-left').photobox('a',{ time:0 });

		$('.fancy-form').fancybox();
		$('.fancy-img').fancybox();
		$('.fancy-map').fancybox();

		$('.view-taxonomy-term .paragraph .item_more').readmore({
			speed: 75,
			collapsedHeight: 65,
			moreLink: '<a href="#" class="rm_button_more">Читать полностью</a>',
			lessLink: '<a href="#" class="rm_button_less">Скрыть</a>'
		});

		function checkMyCookies(){
			let cookieDate = localStorage.getItem('cookieDate');
			let cookieNotification = document.getElementById('cookie_notifys');
			let cookieBtn = cookieNotification.querySelector('.notifys__apply');
			if( !cookieDate || (+cookieDate + 31536000000) < Date.now() ){
				cookieNotification.classList.add('show');
			}
			cookieBtn.addEventListener('click', function(){
				localStorage.setItem( 'cookieDate', Date.now() );
				cookieNotification.classList.remove('show');
			})
		}
		checkMyCookies();

/*		function checkMyCookies(){
			let cookieDate = localStorage.getItem('cookieDate');
			let cookieNotification = document.getElementById('cookie_notifys');
			let cookieBtn = cookieNotification.querySelector('.notifys__apply');
			if( !cookieDate || (+cookieDate + 31536000000) < Date.now() ){
				cookieNotification.classList.add('show');
			}
			cookieBtn.addEventListener('click', function(){
				localStorage.setItem( 'cookieDate', Date.now() );
				cookieNotification.classList.remove('show');
			})
		}
		checkMyCookies();*/
/*
		const container = document.querySelector(".warning");
		if (document.cookie.indexOf("warning") != -1) {
			container.classList.remove("warning--active");
		}

		if (document.querySelector(".warning")) {
			const apply = container.querySelector(".notifys__apply");
			apply.addEventListener("click", () => {
				container.classList.remove("warning--active");
				document.cookie = "warning=true; max-age=2592000; path=/";
			});
		};
*/
	});
})(jQuery);